<template>
  <van-popup
    class="choose-course-card-popup"
    :value="value"
    position="bottom"
    round
    get-container="body"
    @click-overlay="$emit('close')"
  >
    <div class="title">
      <div class="cancel" @click="$emit('close')">取消</div>
      <div>选择本次扣费上课卡</div>
      <div class="submit" @click="submit">确定</div>
    </div>
    <div class="content">
      <div
        class="line flex-between van-hairline--bottom"
        v-for="(ele, idx) in list"
        :key="idx"
        @click="activeIndex = idx"
      >
        <div class="student-amount-item">
          <div class="name">
            <span class="tag" :class="{ card: ele.cardType == 1 }">{{
              ele.cardType == 0 ? '课程' : '课时包'
            }}</span
            >{{ ele.name }}
          </div>
          <div class="amount">
            <span class="label">剩余 </span>
            <span :class="{ owe: ele.remainTotalAmount < 0 }"
              >{{ ele.remainTotalAmount >= 0 ? ele.remainTotalAmount : 0 }}
              <template v-if="ele.remainTotalAmount < 0"
                >(欠费{{ Math.abs(ele.remainTotalAmount) }})</template
              >
            </span>
            <span class="label">{{ lessonUnit }}</span>
            <span v-if="ele.scale">，抵扣比例{{ ele.scale }}倍</span>
          </div>
        </div>
        <van-icon
          class="xiala"
          class-prefix="vxs-icon"
          name="gouxuan2"
          size="20"
          color="var(--c1)"
          v-if="activeIndex == idx"
        />
      </div>
    </div>
  </van-popup>
</template>

<script>

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      activeIndex: 0,
    };
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
  },
  methods: {
    submit() {
      this.$emit('submit', this.activeIndex);
    },
  },
  watch: {
    list(nval){
      if (nval.length) {
        this.activeIndex = nval.findIndex(item => item.defaultSignCard);
      }
    },
    value(v) {
      if (v) {
        this.activeIndex = this.list.findIndex(item => item.defaultSignCard);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  height: 48px;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  font-weight: var(--bold);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  .cancel {
    padding: 6px;
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g6);
    font-weight: 400;
  }
  .submit {
    padding: 6px;
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--c1);
    font-weight: 400;
  }
}
.line {
  padding: calc(var(--gap) * 10) calc(var(--gap) * 16);
}
.student-amount-item {
  // display: flex;
  // justify-content: space-between;
  .name {
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g8);
    margin-bottom: 4px;
    .tag {
      margin-right: calc(var(--gap) * 4);
      display: inline-block;
      font-weight: normal;
      padding: 0 calc(var(--gap) * 2);
      color: var(--white);
      background: var(--c1);
      border-radius: 2px;
      &.card {
        background-color: var(--c4);
      }
    }
  }
  .amount {
    flex-shrink: 0;
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    .label {
      color: var(--g6);
    }
    .owe {
      color: var(--c3) !important;
    }
  }
}
</style>